import { render, staticRenderFns } from "./ConsultationResult.vue?vue&type=template&id=17ed1d60&scoped=true"
import script from "./ConsultationResult.vue?vue&type=script&lang=js"
export * from "./ConsultationResult.vue?vue&type=script&lang=js"
import style0 from "./ConsultationResult.vue?vue&type=style&index=0&id=17ed1d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed1d60",
  null
  
)

export default component.exports